import React from 'react';

import { InfluxCheatSheet } from './InfluxCheatSheet';

export function InfluxStartPage() {
  return <InfluxCheatSheet />;
}
